export const DEFAULT_PARAMS = Object.freeze({
  _order_by: 'name',
  rpp: -1,
  nocache: true,
});

export const ORDER_REMOTES_PARAMS = Object.freeze({
  _order_by: 'name',
  group_type: 'property',
  market_type__in: 'hospitality,healthcare',
  rpp: -1,
});

export const PROPERTY_PARAMS = Object.freeze({
  group_type: 'property',
  rpp: -1,
});

export const GROUP_MARKET_TYPES = Object.freeze({
  healthcare: 'healthcare',
  hospitality: 'hospitality',
});

export const GROUP_DELIVERY_METHOD = Object.freeze({
  onSite: 'on-site',
  integrated: 'integrated',
});
